"use client";

import { useEffect } from "react";
import { trackOaiq } from "@/lib/openai-pixel";

const CAL_ORIGIN = "https://cal.leman-it.com";
const BOOKING_EVENTS = ["bookingSuccessful", "bookingSuccessfulV2"];

// Les iframes Cal.com intégrées (CalInlineEmbed, CalPopup) signalent chaque
// réservation confirmée par postMessage. Selon la version de Cal.com, V1 et
// V2 arrivent toutes les deux pour la même réservation : on dédoublonne sur
// l'uid, qui sert aussi d'event_id côté pixel ChatGPT Ads.
export function CalBookingTracker() {
  useEffect(() => {
    const seen = new Set<string>();

    const onMessage = (e: MessageEvent) => {
      if (e.origin !== CAL_ORIGIN) return;
      const msg = e.data;
      if (msg?.originator !== "CAL" || !BOOKING_EVENTS.includes(msg.type)) return;

      const uid: string | undefined = msg.data?.uid ?? msg.data?.booking?.uid;
      const key = uid ?? "unknown";
      if (seen.has(key)) return;
      seen.add(key);

      trackOaiq(
        "appointment_scheduled",
        { type: "customer_action" },
        uid ? { event_id: `booking_${uid}` } : {},
      );
    };

    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  return null;
}
